import axios from 'axios';
import React, { useState, useContext, useEffect } from 'react';
import { toast } from 'react-toastify';
import { ExclamationDiamondFill } from 'react-bootstrap-icons';
import AuthenticatedContext, {
  AuthenticatedContextType,
} from '../../context/AuthenticatedContext';

const errorMssage: Record<string, string> = {
  lostSession: '認証に失敗しました',
  dataFaild: ' データの取得に失敗しました',
  unexpected: ' 予期せぬエラーが発生しました',
};

// useErrorHandling カスタムフックの実装
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useErrorHandling = () => {
  const [errorMsg, setErrorMsg] = useState('');
  const [oldError, setOldError] = useState<string[]>([]);
  const authContext = useContext<AuthenticatedContextType>(
    AuthenticatedContext,
  );

  // エラーメッセージが更新された時に実行
  useEffect(() => {
    if (errorMsg !== '' && !oldError.includes(errorMsg)) {
      toast.error(() => {
        return (
          <>
            <ExclamationDiamondFill />
            <span>{errorMsg}</span>
          </>
        );
      });
      setOldError((oldErrors) => [...oldErrors, errorMsg]);
    }
  }, [errorMsg, oldError]);

  // エラー確認処理
  const errorCheck = (error: unknown) => {
    if (axios.isAxiosError(error)) {
      // 認証によるエラーの場合
      if (error.response?.status === 401) {
        setErrorMsg(errorMssage.lostSession);
        // ログイン状態を確認
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        authContext.login(undefined).catch(() => {});
      } else {
        // データの取得に失敗
        setErrorMsg(errorMssage.dataFaild);
      }
    } else {
      // 予期せぬエラー
      setErrorMsg(errorMssage.unexpected);
    }
  };

  return { errorCheck };
};

export default useErrorHandling;
